import React from "react";

// Pip positions [row, col] in a 3×3 grid for each d6 face value
const D6_PIPS = {
  1: [[1, 1]],
  2: [[0, 2], [2, 0]],
  3: [[0, 2], [1, 1], [2, 0]],
  4: [[0, 0], [0, 2], [2, 0], [2, 2]],
  5: [[0, 0], [0, 2], [1, 1], [2, 0], [2, 2]],
  6: [[0, 0], [1, 0], [2, 0], [0, 2], [1, 2], [2, 2]],
};

// SVG polygon paths for non-d6 dice (viewBox 0 0 100 100)
const POLYGON_PATHS = {
  4: "M 50 6 L 94 88 L 6 88 Z",
  8: "M 50 4 L 92 35 L 92 65 L 50 96 L 8 65 L 8 35 Z",
  10: "M 50 4 L 94 38 L 76 93 L 24 93 L 6 38 Z",
  12: "M 50 4 L 84 17 L 97 56 L 79 91 L 21 91 L 3 56 L 16 17 Z",
  20: "M 50 4 L 91 28 L 91 72 L 50 96 L 9 72 L 9 28 Z",
};

export default function DiceFace({ value, sides = 6, dropped = false, rolling = false, size = 44 }) {
  const baseClass = [
    "die-face",
    `die-d${sides}`,
    dropped ? "die-dropped" : "",
    rolling ? "die-rolling" : "",
  ]
    .filter(Boolean)
    .join(" ");

  if (sides === 6) {
    const pips = D6_PIPS[Math.min(Math.max(value, 1), 6)] || [];
    return (
      <div className={baseClass} style={{ width: size, height: size }} aria-label={`d6: ${value}`}>
        <div className="die-pips">
          {Array.from({ length: 9 }, (_, i) => {
            const row = Math.floor(i / 3);
            const col = i % 3;
            const active = pips.some(([r, c]) => r === row && c === col);
            return <span key={i} className={`pip${active ? " pip-on" : ""}`} />;
          })}
        </div>
      </div>
    );
  }

  const path = POLYGON_PATHS[sides] || POLYGON_PATHS[8];
  return (
    <div className={baseClass} style={{ width: size, height: size }} aria-label={`d${sides}: ${value}`}>
      <svg viewBox="0 0 100 100" className="die-svg" aria-hidden="true">
        <path d={path} className="die-poly-path" />
        <text x="50" y="56" className="die-poly-text" textAnchor="middle" dominantBaseline="middle">
          {value}
        </text>
      </svg>
    </div>
  );
}
